var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2940_1560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.375 2.1875H2.625C2.38338 2.1875 2.1875 2.38338 2.1875 2.625V11.375C2.1875 11.6166 2.38338 11.8125 2.625 11.8125H11.375C11.6166 11.8125 11.8125 11.6166 11.8125 11.375V2.625C11.8125 2.38338 11.6166 2.1875 11.375 2.1875Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.625 1.3125V3.0625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.375 1.3125V3.0625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1875 4.8125H11.8125",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0625 7.21875C7.0625 7.25327 7.03452 7.28125 7 7.28125C6.96548 7.28125 6.9375 7.25327 6.9375 7.21875C6.9375 7.18423 6.96548 7.15625 7 7.15625C7.03452 7.15625 7.0625 7.18423 7.0625 7.21875Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46875 7.21875C9.46875 7.25327 9.44077 7.28125 9.40625 7.28125C9.37173 7.28125 9.34375 7.25327 9.34375 7.21875C9.34375 7.18423 9.37173 7.15625 9.40625 7.15625C9.44077 7.15625 9.46875 7.18423 9.46875 7.21875Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65625 9.40625C4.65625 9.44077 4.62827 9.46875 4.59375 9.46875C4.55923 9.46875 4.53125 9.44077 4.53125 9.40625C4.53125 9.37173 4.55923 9.34375 4.59375 9.34375C4.62827 9.34375 4.65625 9.37173 4.65625 9.40625Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 9.84375C7.24162 9.84375 7.4375 9.64787 7.4375 9.40625C7.4375 9.16463 7.24162 8.96875 7 8.96875C6.75838 8.96875 6.5625 9.16463 6.5625 9.40625C6.5625 9.64787 6.75838 9.84375 7 9.84375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40625 9.84375C9.64787 9.84375 9.84375 9.64787 9.84375 9.40625C9.84375 9.16463 9.64787 8.96875 9.40625 8.96875C9.16463 8.96875 8.96875 9.16463 8.96875 9.40625C8.96875 9.64787 9.16463 9.84375 9.40625 9.84375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2940_1560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDots);
export default __webpack_public_path__ + "static/media/CalendarDots.543990188216d3c3ffb826a6108f9ccb.svg";
export { ForwardRef as ReactComponent };